import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { Member } from "../member/member";

@Injectable()
export class CommonService {
  messageEvent: Subject<Member> = new Subject();
  profileEvent: Subject<string> = new Subject();
  feedEvent: Subject<boolean> = new Subject();
  activityCountEvent: Subject<boolean> = new Subject();
  myinfoEvent: Subject<boolean> = new Subject();
  thirdPartyModalEvent: Subject<boolean> = new Subject();

  constructor() {}

  addMessageEvent(member: Member) {
    this.messageEvent.next(member);
  }

  addProfileEvent(email: string) {
    this.profileEvent.next(email);
  }

  addFeedEvent() {
    this.feedEvent.next(true);
  }

  addActivityCountEvent() {
    this.activityCountEvent.next(true);
  }

  addMyinfoEvent() {
    this.myinfoEvent.next(true);
  }

  openThirdPartyModal() {
    this.thirdPartyModalEvent.next(true);
  }
}



// WEBPACK FOOTER //
// ./src/app/service/common/common.service.ts